// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar_Avatar__WiKGq","normal":"Avatar_normal__hNcs9","large":"Avatar_large__giqh6"};